export default {
  '0' : { value: 'unknown' },
  '1' : { value: '1' },
  '0.5': { value: '1/2' },
  '0.25': { value: '1/4' },
  '0.125': { value: '1/8' },
  '0.0666666': { value: '1/15' },
  '0.05': { value: '1/20' },
  '0.0333333': { value: '1/30' },
  '0.025': { value: '1/40' },
  '0.0166666': { value: '1/60' },
  '0.008': { value: '1/125' },
  '0.004': { value: '1/250' },
  '0.002': { value: '1/500' },
  '0.0015625': { value: '1/640' },
  '0.001': { value: '1/1000' },
  '0.0005': { value: '1/2000' },
  '0.00025': { value: '1/4000' },
  '0.000125': { value: '1/8000' },
  '0.0000833': { value: '1/12000' },
  '0.0000625': { value: '1/16000' }
}
